export default {
  name: "Merchant",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m29.88 9.53-3.43-6.47A2.002 2.002 0 0 0 24.68 2H7.32c-.75 0-1.42.41-1.77 1.06L2.12 9.53c-.08.15-.12.31-.12.47v18c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V10c0-.16-.04-.32-.12-.47zM4 11h24v2.64c-.43 2.19-2.75 2.36-3.46 2.36-1.59 0-3.09-1.1-3.09-2.27 0-.51-.38-.94-.89-.99-.51-.06-.97.28-1.09.77C18.92 15.97 16.03 16 16 16s-2.92-.03-3.48-2.49a.992.992 0 0 0-1.09-.77c-.51.06-.89.48-.89.99 0 1.17-1.5 2.27-3.09 2.27-.7 0-3.02-.17-3.45-2.36V11zm3.32-7h17.37l2.65 5H4.66l2.66-5zM13 28v-6h6v6h-6zm8 0v-7c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1v7H4V17.02c.92.62 2.09.98 3.46.98 1.69 0 3.24-.77 4.18-1.91C12.91 17.56 14.87 18 16 18c1.13 0 3.09-.44 4.36-1.91.94 1.14 2.5 1.91 4.18 1.91 1.37 0 2.54-.36 3.46-.98V28h-7z",
  },
}
